interface ZapIcon {
  width?: number
  height?: number
  color?: string
}

const ZapIcon = ({ width, height, color }: ZapIcon): JSX.Element => {
  return (
    <svg
      width={width ? width : '20'}
      height={height ? height : '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.833 1.667 3.03 11.03c-.306.367-.459.55-.461.705a.417.417 0 0 0 .155.331c.12.1.359.1.836.1h6.607l-.833 6.667 7.803-9.364c.306-.367.459-.55.461-.705a.417.417 0 0 0-.155-.331c-.12-.1-.359-.1-.836-.1H9.999l.834-6.666Z"
        stroke={color ? color : '#536976'}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ZapIcon
